var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('Toasts',{attrs:{"items":_vm.items,"horizontal":"center","vertical":"top","color":"error"}})
}
var staticRenderFns = []

export { render, staticRenderFns }